var exports = {
  "Lg": "GuildSidebarSkeleton.module__navigation___eGpmVE",
  "X9": "GuildSidebarSkeleton.module__detachedBanner___eGpmVE",
  "GG": "GuildSidebarSkeleton.module__topSpacer___eGpmVE",
  "dl": "GuildSidebarSkeleton.module__membersSection___eGpmVE",
  "ne": "GuildSidebarSkeleton.module__membersSeparator___eGpmVE",
  "vd": "GuildSidebarSkeleton.module__bottomDropZone___eGpmVE",
  "TN": "GuildSidebarSkeleton.module__groups___eGpmVE",
  "Os": "GuildSidebarSkeleton.module__group___eGpmVE",
  "nM": "GuildSidebarSkeleton.module__row___eGpmVE",
  "bQ": "GuildSidebarSkeleton.module__rowCategory___eGpmVE",
  "me": "GuildSidebarSkeleton.module__categoryCaret___eGpmVE",
  "et": "GuildSidebarSkeleton.module__rowChannel___eGpmVE",
  "Ec": "GuildSidebarSkeleton.module__rowMembers___eGpmVE",
  "p": "GuildSidebarSkeleton.module__channelIcon___eGpmVE",
  "US": "GuildSidebarSkeleton.module__bottomSpacer___eGpmVE",
};

module.exports = exports;
